import { useEffect } from 'react'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { useUser } from '../generic/hooks/useUser'
import SmartMateriaUITable from '../generic/SmartMateriaUITable'

const PendingCellMoves = () => {
  const { user } = useUser()
  const { t_ } = useSmartTranslation()

  useEffect(() => {
    window.secretGame = () => {
      const insertedNumber = window.prompt('¿Cuánto es 1 + 1?')

      const randomNumber = Math.floor(Math.random() * 100)

      if (Number(insertedNumber) === randomNumber) {
        console.warn('%c🎉 ¡Correcto!', 'color:#00ff99;font-size:16px;font-weight:bold;')
      } else {
        console.error(`%c❌ Incorrecto. El número correcto era ${randomNumber}.`, 'color:#ff3300;font-size:16px;font-weight:bold;')
      }
    }

    console.warn('%c🎮 Debuggeame esto', 'color:#00ff99;font-size:16px;font-weight:bold;')
    console.warn('%cEjecutando... escribe secretGame()', 'color:#66ccff;font-size:14px;')

    return () => {
      delete window.secretGame
    }
  }, [])

  if (!user || !user.profile || user.profile.code !== 'SUPERADMIN') {
    return null
  }

  const columns = [
    {
      field: 'resource',
      name: t_('Resource')
    },
    {
      field: 'deviceFrom',
      name: t_('Device from')
    },

    {
      field: 'deviceTo',
      name: t_('Device to')
    }
  ]

  return (
    <SmartMateriaUITable
      title={t_('Pending cell moves')}
      dataFetch='debug/pendingCellMoves'
      columns={columns}
    />
  )
}

export default PendingCellMoves
